export enum BusinessHoursWeekday {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday'
}

export enum BusinessHoursErrorCode {
  storageUnavailable = 'storage_unavailable',
  invalidSettings = 'invalid_settings'
}

export type BusinessHoursDayServer = {
  weekday: BusinessHoursWeekday;
  day_off: boolean;
  start: string | null;
  end: string | null;
};

export type BusinessHoursAutoReplyServer = {
  enabled: boolean;
  text: string;
};

export type BusinessHoursSettingsServer = {
  enabled: boolean;
  schedule: BusinessHoursDayServer[];
  auto_reply: BusinessHoursAutoReplyServer;
};
